export default "__VITE_ASSET__DBCXqZgq__"